<template>
  <div class="buy">
    <div class="container" v-if="!license">
      <div class="intro">
        <el-row>
          <el-col>
            <h2>Get the only add-on that saves you more than it costs.</h2>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <ul>
              <li>Auto-Defend pairs that meet a target threshold</li>
              <li>Works with every exchange</li>
              <li>Unlimited Sessions and Bags</li>
            </ul>
          </el-col>
        </el-row>
      </div>
      <div class="main-banner">
        <div class="container">
          <router-link to="/buy/lifetime">
            <span>Looking for a Lifetime License? Click Here</span>
          </router-link>
        </div>
      </div>
      <div class="step plans">
        <el-row>
          <el-col>
            <h5><el-tag>Step 1</el-tag> Choose a Plan</h5>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-card class="plan-silver" :class="{'selected': quantity === 3}">
              <div class="plan-title">Silver</div>
              <div class="plan-price">{{ silverPrice | currency }} <span class="time">/ month</span></div>
              <div class="plan-time">
                <span v-if="isYearly">Billed yearly</span>
              </div>
              <hr>
              <ul>
                <li class="quantity"><strong>3</strong> Concurrent Pairs</li>
                <li><strong>Unlimited</strong> Sessions and Bags</li>
                <li><strong>VPS</strong> Compatible</li>
                <li><strong>Any</strong> Exchange</li>
                <li><strong>Upgrade</strong> or cancel anytime</li>
              </ul>
              <el-button class="plan-button" @click="quantity = 3" v-if="quantity > 3" />
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card class="plan-gold" :class="{'selected': quantity >= 10}">
              <div class="plan-title">Gold</div>
              <div class="plan-price">{{ goldPrice | currency }} <span class="time">/ month</span></div>
              <div class="plan-time">
                <span v-if="isYearly">Billed yearly</span>
              </div>
              <hr>
              <ul>
                <li class="quantity">
                  <strong v-if="quantity < 10">10</strong>
                  <el-input-number v-else v-model="quantity" :min="10" :max="1000" :step="5" />
                    Concurrent Pairs
                </li>
                <li><strong>Unlimited</strong> Sessions and Bags</li>
                <li><strong>VPS</strong> Compatible</li>
                <li><strong>Any</strong> Exchange</li>
                <li><strong>Upgrade</strong> or cancel anytime</li>
              </ul>
              <el-button class="plan-button" @click="quantity = 10" v-if="quantity < 10" />
            </el-card>
          </el-col>
        </el-row>
      </div>
      <div class="step">
        <el-row>
          <el-col>
            <h5><el-tag>Step 2</el-tag> Choose a Payment Plan</h5>
          </el-col>
        </el-row>
        <el-row class="payment-plans">
          <el-radio v-model="plan" :label="PLANS.YEARLY" border>
            {{ pricePerQuantity(quantity, true) | currency }} per Year
          </el-radio>
          <br>
          <el-radio v-model="plan" :label="PLANS.MONTHLY" border>
            {{ pricePerQuantity(quantity, false) | currency }} per Month
          </el-radio>
        </el-row>
      </div>
      <div class="step">
        <el-row>
          <el-col>
            <h5><el-tag>Step 3</el-tag> Create an Account</h5>
          </el-col>
        </el-row>
        <el-row>
          <el-col :md="10">
            <el-input v-model="email" placeholder="john@doe.com">
              <template slot="prepend">Email</template>
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <label class="muted">We will never share your information or send spam.</label>
          </el-col>
        </el-row>
      </div>
      <div class="step">
        <el-row>
          <el-col>
            <h5><el-tag>Step 4</el-tag> Payment Details</h5>
          </el-col>
        </el-row>
        <el-row>
          <el-col :md="10">
            <div ref="cardElement"></div>
          </el-col>
        </el-row>
        <el-row class="final-price">
          <el-col :md="10">
            <hr class="dark">
            <h5>Your card will be charged</h5>
            <h3>{{ pricePerQuantity(quantity) | currency }} <span class="time">/ {{ isYearly ? "year" : "month" }}</span></h3>
          </el-col>
        </el-row>
        <el-row>
          <el-col :md="10">
            <hr class="dark">
            <div>
              <label class="muted">
                By completing this purchase, you agree to our
                <br>
                <router-link to="/terms" target="_blank">Terms of Service</router-link> and <router-link to="/privacy" target="_blank">Privacy Policy</router-link>.
                <br><br>
              </label>
            </div>
            <el-button type="primary" @click="purchase" :loading="loading" :disabled="loading">
              Complete Purchase
            </el-button>
          </el-col>
        </el-row>
      </div>
    </div>
    <div v-if="license" class="container license">
      <el-row type="flex" justify="center">
        <el-col :md="12">
          <el-card>
            <h1>Purchase Complete</h1>
            <p>
              Here is your PTDefender License:
            </p>
            <p>
              <code>
                <pre>{{ license }}</pre>
              </code>
            </p>
            <hr>
            <p class="mb-0">
              <strong>Important:</strong> Make sure you keep this license in a safe place. After downloading PTDefender you will need to enter this license in order to activate it.
            </p>
            <br>
            <p>
              <router-link to="/download">Download PTDefender</router-link>
            </p>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import api from 'lib/api'
import referral from 'lib/referral'
import Stripe from 'lib/stripe'

const PLANS = {
  MONTHLY: 'plan_DqbfKGV9KDY9Co',
  YEARLY: 'plan_Dqbg9zQjYFO59L'
}

export default {
  name: 'Buy',
  props: [
    'referral'
  ],
  data() {
    return {
      stripe: null,
      email: null,
      card: null,
      loading: false,
      license: null,
      plan: PLANS.YEARLY,
      quantity: window.location.search.includes('silver') ? 3 : 10
    }
  },
  computed: {
    PLANS() {
      return PLANS
    },
    isYearly() {
      return this.plan === PLANS.YEARLY
    },
    goldPrice() {
      let quantity = Math.max(10, this.quantity)
      return this.monthlyPrice(quantity)
    },
    silverPrice() {
      return this.monthlyPrice(3)
    }
  },
  filters: {
    currency(val) {
      return '$' + parseFloat(val).toLocaleString('en', {
        useGrouping: true,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    }
  },
  methods: {
    pricePerQuantity(quantity, yearly = this.isYearly) {
      if (yearly) {
        if (quantity === 3) return 99
        return 199 + (5 * (quantity - 10))
      } else {
        if (quantity === 3) return 14.99
        return 19.99 + (1 * (quantity - 10))
      }
    },
    monthlyPrice(quantity) {
      let price = this.pricePerQuantity(quantity)
      return this.isYearly ? (price / 12) : price
    },
    getReferral() {
      return referral.current() || this.referral || null
    },
    async purchase(event) {
      if (event) event.preventDefault()
      this.loading = true
      try {
        let token = await this.stripe.createToken(this.card)
        let auth = await api.register({
          token: token.id,
          email: this.email,
          plan: this.plan,
          quantity: this.quantity,
          referral: this.getReferral()
        })
        this.license = auth.token
      } catch(err) {
        this.alertError(err)
      }
      this.loading = false
    },
    alertError(err) {
      if (err.type === 'validation_error') return
      let title = err.response ? err.response.data.title : 'Error'
      let message = err.response ? err.response.data.message : err.message
      return this.$alert(message || 'Please try again', title || 'Something went wrong')
    }
  },
  async mounted() {
    this.stripe = new Stripe()
    this.card = this.stripe.createCard(this.$refs.cardElement)
    if (this.referral) {
      referral.set(this.referral)
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.buy {
  padding: 20px 0 80px 0;

  hr.dark {
    border-bottom: 1px solid #dfdfdf;
  }

  h2 {
    padding-left: 20px;
    font-weight: bold;
    font-size: 1.6em;
  }

  .main-banner {
    padding: 15px 10px;
    background-color: $--color-primary;
    text-align: center;
    border-radius: 3px;
    margin: 10px auto;

    a {
      color: #fff;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }

    span {
      color: #fff;
      font-weight: 400;
      text-decoration: none;
    }
  }

  .intro {
    padding: 40px 0 0 0;
    ul {
      li {
        margin: 10px 0;
      }
    }
  }

  .container.license {
    padding: 100px 0;
  }

  .step {
    padding-top: 50px;
    padding-left: 20px;
    padding-bottom: 10px;
    h5 {
      font-weight: bold;
      font-size: 1.1em;
      padding-bottom: 8px;
    }
    .input-group {
      max-width: 400px;
    }
    label.muted {
      display: block;
      padding-top: 8px;
      font-size: 12px;
      color: #333;
    }
    .el-tag {
      margin-right: 8px;
      margin-bottom: 10px;
      transform: translate(0, -2px);
    }
  }

  code pre {
    padding: 8px;
    background-color: #f4f5f6;
    border-radius: 3px;
    border: 1px solid darken(#f4f5f6, 10%);
  }

  .final-price {
    margin-top: 20px;
    h5 {
      font-weight: 400;
      font-size: 16px;
    }
    h3 {
      font-weight: 500;
      font-size: 24px;
      span.time {
        font-size: 16px;
        font-weight: 400;
      }
    }
  }

  .el-card {
    &.selected {
      border: 3px solid $--color-primary;
    }
  }

  .el-radio {
    background-color: #fff;
    margin-bottom: 10px;
  }

  .badge {
    margin-right: 6px;
    margin-bottom: 4px;
  }

  .btn-primary {
    color: #fff !important;
    padding: 10px 30px !important;
  }

  a {
    color: #1b6163;
    text-decoration: underline;
  }

  .plans {
    .el-card__body {
      position: relative;
    }
    .el-input-number {
      width: 140px;
      margin-right: 8px;
      .el-input__inner {
        font-weight: 500;
        font-size: 16px;
      }
    }
    .el-button.plan-button {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: block;
      border: none;
      background-color: rgba(0,0,0,0);
    }
    .plan-title {
      text-transform: uppercase;
      font-weight: 600;
      font-size: 18px;
      opacity: 0.5;
      text-align: center;
    }
    .plan-price {
      margin-top: 8px;
      font-size: 24px;
      text-align: center;
      span.time {
        font-size: 14px;
      }
    }
    .plan-time {
      margin-top: 6px;
      text-align: center;
      font-size: 12px;
      height: 15px;
    }
    ul {
      padding: 0;
      list-style-type: none;
      text-align: left;
      li {
        margin: 10px 0;
        &.quantity strong {
          font-size: 24px;
        }
      }
    }
  }

  .payment-plans {
    .el-radio {
      height: 44px;
      width: 200px;
      .el-radio__label {
        font-size: 16px;
      }
    }
  }
}
</style>
